import selectedOrgId from '../../utils/helpers/selectedOrgId'
import axiosInstance from '../../Apis/axiosInterceptor/axiosInstance'

const positionsProvider = {
  getList: () => {
    const url = `v1/orgs/${selectedOrgId()}/players/positions`

    return axiosInstance.get(url).then(({data}) => {
      return {
        data: data,
        total: data.length,
      }
    })
  },

  getMany: () => {
    return Promise.reject('Provider: positions, Method: getMany')
  },
}

export default positionsProvider
